import { useDestinationContext } from '@/src/contexts'

import DestinationOverview from './destinationOverview'

const DestinationOverviewWrapper = () => {
    const { destinationData: { sections } } = useDestinationContext()
    const info = sections.destinationInfo
    if (!info?.overview) return null

    return (
        <DestinationOverview
            title={`About ${info.city}${info.country ? `, ${info.country}` : ''}`}
            overview={info.overview}
            travelTips={info.travelTips ?? []}
        />
    )
}

export default DestinationOverviewWrapper
